<template>
  <div class="payment-options">
    <h2>Make your Deposit NOW with:</h2>
    <div class="buttons">
      
      <!-- Airtel Instant -->
      <DepositMethodButton
        method-name="airtel"
        method-class="airtel"
        icon="/icons/airtel.png"
        button-text="Airtel Instant"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!-- tnm -->
      <DepositMethodButton
        method-name="tnm"
        method-class="tnm"
        icon="/icons/tnm.png"
        button-text="TNM Mpamba"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!-- Paychangu Mobile -->
      <!-- <DepositMethodButton
        method-name="paychangu"
        method-class="paychangu"
        icon="/icons/paychangu.png"
        button-text="Paychangu Mobile"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      /> -->

      <!-- Paychangu Debit/Credit Card -->
      <DepositMethodButton
        method-name="paychangu-card"
        method-class="paychangu"
        icon="/icons/paychangu.png"
        button-text="Debit/Credit Card"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!-- Paychangu Bank Transfer -->
      <DepositMethodButton
        method-name="paychangu-bank"
        method-class="paychangu"
        icon="/icons/paychangu.png"
        button-text="Bank Transfer"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!-- AIRTEL MERCHANT -->
      <DepositMethodButton
        method-name="paybill1"
        method-class="airtel"
        icon="/icons/airtel.png"
        button-text="Airtel Paybill 1"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!-- AIRTEL MERCHANT -->
      <DepositMethodButton
        method-name="paybill2"
        method-class="airtel"
        icon="/icons/airtel.png"
        button-text="Airtel Paybill 2"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!-- AIRTEL MERCHANT -->
      <DepositMethodButton
        method-name="paybill"
        method-class="airtel"
        icon="/icons/airtel.png"
        button-text="Airtel Merchant"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!-- Vodacom Merchant - ->
      <DepositMethodButton
        method-name="vodacom-merchant"
        method-class="vodacom"
        icon="/icons/vodacom.png"
        button-text="Vodacom Merchant"
        :text-style="{ paddingLeft: '10px' }"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!- - MyWallet -- >
      <DepositMethodButton
        method-name="mywallet"
        method-class="mywallet"
        icon="/icons/mywallet.webp"
        button-text="MyWallet"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <! -- Help/Thuso -- >
      <div style="margin-top: 15px;">
        <DepositMethodButton
          method-name="help"
          method-class="help"
          button-text="Thuso / Help"
          :text-style="{ paddingLeft: '10px' }"
          :show-info="false"
          @click="handleMethodClick"
        />
      </div>
       -->
    </div>
  </div>
</template>

<script>
import DepositMethodButton from './DepositMethodButton.vue';

export default {
  name: 'DepositMethodsGridMalawi',
  components: {
    DepositMethodButton
  },
  props: {
    username: {
      type: String,
      default: ''
    }
  },
  emits: ['method-selected', 'info-requested'],
  methods: {
    handleMethodClick(methodName) {
      this.$emit('method-selected', methodName);
    },
    handleInfoClick(methodName) {
      this.$emit('info-requested', methodName);
    }
  }
};
</script>

<style scoped>
.payment-options {
  padding: 30px 16px 24px;
  text-align: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  box-sizing: border-box;
  overflow: hidden;
}

.payment-options h2 {
  font-size: 28px;
  font-weight: 700;
  color: #1a2332;
  margin-bottom: 40px;
  letter-spacing: -0.5px;
}

.buttons {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 120px));
  gap: 24px;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px 0;
  justify-content: center;
  justify-items: center;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .buttons {
    grid-template-columns: repeat(auto-fit, minmax(120px, 120px));
    gap: 20px;
  }
  
  .payment-options h2 {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .buttons {
    grid-template-columns: repeat(2, minmax(120px, 120px));
    gap: 16px;
  }
}

.blue {
  color: blue;
}

.red {
  color: red;
}
</style>
